// getUserMedia rejects with a DOMException; older browsers use the legacy names.
const BLOCKED = ['NotAllowedError', 'PermissionDeniedError', 'SecurityError'];
const MISSING = ['NotFoundError', 'DevicesNotFoundError', 'OverconstrainedError'];

/**
 * @param {unknown} error - what getUserMedia (or call setup) threw
 * @returns {'micBlocked' | 'noMic' | 'unknown'}
 */
export const getMicErrorType = (error) => {
  const name = error && error.name;
  if (BLOCKED.includes(name)) return 'micBlocked';
  if (MISSING.includes(name)) return 'noMic';
  return 'unknown';
};
